const VideosDjSets = [
  {
    video_id: 'OJCuCMV5J2Q',
    title: 'Boiler Room Ibiza DJ Set',
    artist: 'Jamie Jones B2B Martinez Brothers',
  },
  {
    video_id: 'rp4-5RAy7J0',
    title: '2014 Full Set',
    artist: 'RICHIE HAWTIN vs DUBFIRE',
  },
  {
    video_id: 'RWVBoK4idas',
    title: 'at Pliva Waterfalls in Jajce, Bosnia-Herzegovina',
    artist: 'Jamie Jones',
  },
  {
    video_id: 'ltVADtnqDJg',
    title: 'Mixmag DJ set at The BPM Festival 2014',
    artist: 'Apollonia',
  },
  {
    video_id: 'Jd5rjV_8V2k',
    title: 'Kappa Futur Festival 2018',
    artist: 'The Martinez Brothers',
  },
  {
    video_id: 'RrKEfwxZwIo',
    title: 'Paris-Charles de Gaulle Airport in France',
    artist: 'Tale Of Us',
  },
  {
    video_id: 'qJzT_Ww8q9g',
    title: 'CRSSD Fest - Spring 2015',
    artist: 'JAMIE JONES b2b SETH TROXLER',
  },
  {
    video_id: '6dYo4mCDnZI',
    title: 'Awakenings Festival 2018',
    artist: 'Amelie Lens',
  },
  {
    video_id: 'zfAcYG2HE2s',
    title: 'Boiler Room x Dekmantel Festival 2022',
    artist: 'Palms Trax',
  },
  {
    video_id: 'D2LhYfyqC74',
    title: 'Tomorrowland Belgium 2018',
    artist: 'Camelphat',
  },
  {
    video_id: '7BfQFqiIKJ0',
    title: 'Tomorrowland Belgium 2017',
    artist: 'Route 94',
  },
  {
    video_id: 'jDyLG7aaeJE',
    title: 'Ultra Resistance 2018 Day 2',
    artist: 'Jamie Jones',
  },
  {
    video_id: 'sy0t9xoTdBU',
    title: 'Pukkelpop 2018',
    artist: 'Charlotte de Witte',
  },
  {
    video_id: '9-3Km2aHrts',
    title: 'Resistance Ibiza: Week 7',
    artist: 'Technasia',
  },
  {
    video_id: 'J3L_JYi9WR8',
    title: 'Kappa Futur Festival',
    artist: 'Patrick Topping',
  },
  {
    video_id: 'CQZYzGO8QlM',
    title: "Signal 2108 Alpe d'Huez in the Alps, France",
    artist: 'Adriatique',
  },
];

export default VideosDjSets;
